import { render, staticRenderFns } from "./keywordHead.vue?vue&type=template&id=1f854651&scoped=true"
import script from "./keywordHead.vue?vue&type=script&lang=js"
export * from "./keywordHead.vue?vue&type=script&lang=js"
import style0 from "./keywordHead.vue?vue&type=style&index=0&id=1f854651&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f854651",
  null
  
)

export default component.exports